import dayjs from 'dayjs';
import * as Sentry from '@sentry/vue';

const LOCALE_LOADERS: Record<string, () => Promise<unknown>> = {
  de: () => import('dayjs/locale/de'),
  es: () => import('dayjs/locale/es'),
  fr: () => import('dayjs/locale/fr'),
  it: () => import('dayjs/locale/it'),
  'pt-br': () => import('dayjs/locale/pt-br'),
};

export function toDayjsLocale(appLocale: string): string {
  switch (appLocale) {
    case 'es-419':
      return 'es';
    case 'pt':
      return 'pt-br';
    default:
      return appLocale || 'en';
  }
}

export async function setDayjsLocale(appLocale: string): Promise<void> {
  try {
    const dayjsLocale = toDayjsLocale(appLocale);

    if (dayjsLocale !== 'en') {
      const loader = LOCALE_LOADERS[dayjsLocale];
      if (!loader) {
        dayjs.locale('en');
        return;
      }
      await loader();
    }

    dayjs.locale(dayjsLocale);
  } catch (error) {
    Sentry.captureException(error);
    dayjs.locale('en');
  }
}
